module.exports = __webpack_public_path__ + "static/media/logo-comjoodoc.2acfb4a6.svg";